import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "src/modules/notification/redux";
import ProductSelectComponent from "./productSelect.component";
import { getProductList } from "../../../redux/action/companies.action";
import { resetProductDropdown } from "../../../redux/slice/companies.slice";

function ProductSelectContainer({
  placeholder,
  handleProductChange,
  selectedProduct,
  fetchAllProduct = false,
  selectedCompany,
}) {
  const dispatch = useDispatch();
  const isFetching = useSelector((state) =>
    selectLoading(state, getProductList.typePrefix)
  );
  const dropdown = useSelector((state) => state.companies.productDropdown.list);
  const hasNextPage = useSelector(
    (state) => state.companies.productDropdown.hasNextPage
  );
  const totalFiltered = useSelector(
    (state) => state.companies.productDropdown.totalFiltered
  );
  const isError = useSelector(
    (state) => state.companies.productDropdown.isError
  );

  const [filter, setFilter] = useState({
    length: fetchAllProduct ? -1 : 25,
    page: 0,
    search: "",
  });

  // Track previous company id to detect changes
  const [prevCompanyId, setPrevCompanyId] = useState(null);

  useEffect(() => {
    if (!selectedCompany?.company?.id) return;

    // If company changed, reset dropdown and filter only
    if (prevCompanyId !== selectedCompany.company.id) {
      dispatch(resetProductDropdown());
      setFilter({
        length: fetchAllProduct ? -1 : 25,
        page: 0,
        search: "",
      });
      setPrevCompanyId(selectedCompany.company.id);
      // Do NOT call getProductList here; let the next effect run with new filter
      return;
    }

    // Only call API when filter changes and company is the same
    dispatch(
      getProductList({
        companyUuid: selectedCompany.company.id,
        length: filter.length,
        start: filter.page * filter.length,
        search: filter.search,
      })
    );
  }, [filter, selectedCompany?.company?.id]);

  const handleItemSearch = (searchText) => {
    dispatch(resetProductDropdown());
    setFilter({
      ...filter,
      page: 0,
      search: searchText,
    });
  };

  return (
    <ProductSelectComponent
      selectedProduct={selectedProduct}
      placeholder={placeholder}
      productDropdown={dropdown}
      isFetching={isFetching}
      handleItemSearch={handleItemSearch}
      handleProductChange={handleProductChange}
      isError={isError}
    />
  );
}

export default ProductSelectContainer;
